function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M1227.69,458.477c-56.538,72.3-163.224,88.859-251.5,63.676a409.353,409.353,0,0,1-83.088-34.589c-15.3-8.309-30.234-17.423-44.863-27.135-3.6-2.379-7.2-4.795-10.761-7.26q-3.642-2.489-7.26-5.039c-30.21-21.254-59.235-44.57-87.773-67.751C671.208,322.51,598.015,262.86,510.486,235.249c-18.033-5.686-41.361-8.345-52.513,6.93-9.675,13.262-3.77,32.04,4.417,46.266,30.368,52.7,85.491,85.967,140.664,111.553S716.669,446.312,764.63,483.72,849.207,580.583,839.4,640.6c-8.455,51.719-50.682,93.739-99.779,112.053S635.764,768.4,584.728,756.52s-99.486-32.65-148.741-50.536c-29.7-10.8-68.52-18.265-88.225,6.442-16.642,20.876-7.076,53.806,13.189,71.18s47.694,23.194,73.864,28.416Q556.7,836.362,678.59,860.691c24.926,4.966,50.438,10.163,72.156,23.389s39.238,36.3,38.616,61.712c-.623,25.048-18.96,47.181-41.435,58.271s-48.4,12.786-73.425,11.591c-93.776-4.49-362.622-153.475-427.1-172.521-41.434-12.225-86.736-30.185-104.208-69.692C121.436,724.261,157.234,664.757,206.1,642.3s105.489-17.5,158.734-9.932,108.246,17.191,160.076,2.818,99.315-61.224,94.2-114.762c-4.454-46.583-46.412-81.685-90.568-97.156-34.565-12.115-71.338-15.41-107.648-20.863-10.078-1.5-20.12-3.184-30.063-5.259a374.667,374.667,0,0,1-74.12-23.792A381.8,381.8,0,0,1,245.9,332.71,372.453,372.453,0,0,1,196.7,289.995q-3.459-3.587-6.845-7.333c-2.147-2.391-4.27-4.832-6.344-7.321-26.988-32.247-46.925-71.961-40.946-112.883,5.966-40.812,37.774-74.791,75.646-91.116,21.888-9.431,45.5-13.653,69.4-14.263a285.252,285.252,0,0,1,52.2,3.758c79.806,12.762,152.938,51.537,222.008,93.52s136.357,88.066,211.429,117.995S933.771,314.97,1009.929,287.9s138.724-100.9,135-181.635c50.511,43.5,93.434,98.168,112.443,162.052S1268.746,405.964,1227.69,458.477Z",
  transform: "translate(-136.684 -57.003)",
  fill: "#898989"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 8.879,
  cy: 8.879,
  r: 8.879,
  transform: "translate(718.184 300.279)",
  fill: "#ee4b51"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 13.728,
  cy: 13.728,
  r: 13.728,
  transform: "translate(1026.898 178.302)",
  fill: "#ee4b51"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11",
  "data-name": "Ellipse 11",
  cx: 5.072,
  cy: 5.072,
  r: 5.072,
  transform: "translate(135.129 618.869)",
  fill: "#ee4b51"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M390.006,339.157a54.206,54.206,0,0,1-1.586,13.055c-10.078-1.5-20.12-3.184-30.063-5.259a374.662,374.662,0,0,1-74.12-23.792,54.1,54.1,0,0,1,105.769,16Z",
  transform: "translate(-104.209 -6.814)",
  fill: "#a1dd30"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_12",
  "data-name": "Ellipse 12",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(947.592 275.909)",
  fill: "#f0f0f0"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(472.978 846.91)",
  fill: "#f7f115"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_14",
  "data-name": "Ellipse 14",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(547.403 918.895)",
  fill: "#f0f0f0"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_15",
  "data-name": "Ellipse 15",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(87.43 713.92)",
  fill: "#f0f0f0"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_16",
  "data-name": "Ellipse 16",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(342.428 617.533)",
  fill: "#f0f0f0"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_17",
  "data-name": "Ellipse 17",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(316.807 102.656)",
  fill: "#5958a5"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_18",
  "data-name": "Ellipse 18",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(630.369 508.946)",
  fill: "#f7f115"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_19",
  "data-name": "Ellipse 19",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(669.412 599.232)",
  fill: "#f0f0f0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  d: "M291.527,244.343Q302.6,241,312.71,237.1c41.435-16,65.2-37.714,65.2-59.565s-23.764-43.561-65.2-59.565q-6.146-2.374-12.672-4.543a166.347,166.347,0,0,1-8.511,130.915Z",
  transform: "translate(-102.605 -44.589)",
  fill: "none"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  d: "M342.794,181.4a165.249,165.249,0,0,1-18.057,75.353q-2.361,4.612-5,9.065A166.458,166.458,0,0,1,245.028,332.7a372.453,372.453,0,0,1-49.194-42.715q-3.459-3.587-6.845-7.333c-2.147-2.391-4.27-4.832-6.344-7.321C155.657,243.084,135.72,203.37,141.7,162.448c5.966-40.812,37.774-74.791,75.645-91.116,21.888-9.431,45.5-13.653,69.4-14.263a166.087,166.087,0,0,1,43.106,59.98c1.22,2.892,2.342,5.82,3.4,8.785A165.635,165.635,0,0,1,342.794,181.4Z",
  transform: "translate(-135.814 -56.993)",
  fill: "#02b4a7"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  d: "M410.861,179.117c0,25.414-24.816,48.987-69.886,66.4-9.017,3.489-18.668,6.649-28.819,9.48-37.994,10.59-83.21,16.459-130.745,16.837-2.147-2.391-4.27-4.832-6.344-7.321.512.012,1.025.012,1.537.012,51.622,0,100.6-6.54,140.554-18.594,7.381-2.233,14.458-4.649,21.181-7.247,41.434-16,65.2-37.713,65.2-59.565s-23.767-43.557-65.2-59.565q-6.149-2.379-12.664-4.539c-1.062-2.965-2.184-5.893-3.4-8.785q9.736,3.038,18.7,6.491C386.044,130.131,410.861,153.715,410.861,179.117Z",
  transform: "translate(-128.236 -46.173)",
  fill: "#e4e4e4"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_20",
  "data-name": "Ellipse 20",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(50.827 31.891)",
  fill: "#f0f0f0"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_21",
  "data-name": "Ellipse 21",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(159.415 64.833)",
  fill: "#f0f0f0"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_22",
  "data-name": "Ellipse 22",
  cx: 50.449,
  cy: 50.449,
  r: 50.449,
  transform: "translate(58.03 72.036)",
  fill: "#f0f0f0"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_23",
  "data-name": "Ellipse 23",
  cx: 5.188,
  cy: 5.188,
  r: 5.188,
  transform: "translate(110.612 240.526)",
  fill: "#f0f0f0"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M452.018,709h21.458l10.208-82.767h-31.67Z",
  transform: "translate(99.483 137.823)",
  fill: "#ffb6b6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M584.215,747.065h6.04l23.58-9.589,12.638,9.588h0a26.931,26.931,0,0,1,26.93,26.928v.877l-69.189,0Z",
  transform: "translate(-38.187 92.756)",
  fill: "#5958a5"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  d: "M326.02,709H304.562l-10.208-82.767h31.67Z",
  transform: "translate(64.784 137.823)",
  fill: "#ffb6b6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M473.958,774.871l-69.189,0v-.875a26.931,26.931,0,0,1,26.929-26.93h0l12.638-9.588,23.58,9.589h6.04Z",
  transform: "translate(-77.681 92.756)",
  fill: "#5958a5"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M534.66,231.191l-21.727,16.545-57.717,15.285s20.681,145.142,10.92,154.9-.958,10.023-2.919,22.7-9.777,46.157-9.777,46.157H625.7s1.388-20.805-7.1-25.311,7.828-25.535.888-29.052,2.821-34.018,2.821-34.018l21.153-99.864L587.2,254.518,578.641,233.9Z",
  transform: "translate(-66.969 -18.671)",
  fill: "#5958a5"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  "data-name": "Ellipse 24",
  cx: 7.517,
  cy: 7.517,
  r: 7.517,
  transform: "translate(487.284 327.183)",
  fill: "#f2f2f2"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  "data-name": "Path 76",
  d: "M459.406,440.678l-7.1,182.917s-30.671,135.1-25.344,138.652,7.585,24.73,7.585,24.73l30.19,3.552s0-14.207,7.1-19.535,72.812-255.728,72.812-255.728l64.1,242.1s1.6,13.627,6.932,13.627,7.1,19.535,7.1,19.535h30.19V770.993s13.565-4.3,8.237-18.508-29.548-311.808-29.548-311.808Z",
  transform: "translate(-72.934 27.435)",
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_25",
  "data-name": "Ellipse 25",
  cx: 36.406,
  cy: 36.406,
  r: 36.406,
  transform: "translate(453.847 128.808)",
  fill: "#ffb6b6"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M464.734,257.174s-8.879-1.776-14.207,14.207-24.862,76.363-24.862,87.019,121.655,57.67,121.655,57.67l-12.658-44.406-55.72-29.246Z",
  transform: "translate(-73.082 -12.965)",
  fill: "#5958a5"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_26",
  "data-name": "Ellipse 26",
  cx: 20.742,
  cy: 20.742,
  r: 20.742,
  transform: "translate(459.139 355.038)",
  fill: "#ffb6b6"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  d: "M580.465,316.785H579.8V298.474a10.6,10.6,0,0,0-10.6-10.6H530.4a10.6,10.6,0,0,0-10.6,10.6V398.932a10.6,10.6,0,0,0,10.6,10.6h38.8a10.6,10.6,0,0,0,10.6-10.6V329.82h.668Z",
  transform: "translate(-52.363 -6.195)",
  fill: "#f0f0f0"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M619.435,286.39s5.328,3.552,8.879,19.535,26.638,76.363,17.759,90.57-11.5,29.37-41.691,8.06l-41.776-38.25,30.19-28.414,12.431,8.879Z",
  transform: "translate(-42.943 -6.522)",
  fill: "#5958a5"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_28",
  "data-name": "Ellipse 28",
  cx: 20.742,
  cy: 20.742,
  r: 20.742,
  transform: "translate(502.875 316.287)",
  fill: "#ffb6b6"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  d: "M509.726,209.812l-5-19.023c-1.3-4.964-2.619-10.028-2.326-15.151s2.466-10.411,6.783-13.187,10.906-2.12,13.684,2.2c.528-6.891,6.8-12.191,13.447-14.069s13.712-1.135,20.616-.818,14.191.1,20.149-3.406a6.237,6.237,0,0,1-2.793,7.371,6.055,6.055,0,0,0,7.315-3.858,15.713,15.713,0,0,1-4.126,10.792,11.56,11.56,0,0,1,14.941,4.231c3.041,5.272,1.337,11.892-.442,17.712l-9.131,29.871c-1.385-4.541-1.646-9.335-2.387-14.024s-2.059-9.478-5.154-13.077-8.353-5.684-12.751-3.9c-2.468,1-4.349,3.037-6.577,4.5-4.571,3-10.385,3.425-15.816,2.816s-10.723-2.156-16.154-2.774c-3.4-.387-7.194-.284-9.759,1.98a12.544,12.544,0,0,0-3.341,6.67,53.059,53.059,0,0,0-1.413,15.3",
  transform: "translate(-56.203 -37.343)",
  fill: "#2f2e41"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  d: "M1932.427-45.608c-2.792,0-5.583-.007-8.375.005-.656,0-1.252-.09-1.566-.741a1.594,1.594,0,0,1,.288-1.719q4.134-5.815,8.245-11.646c.945-1.333,1.985-1.329,2.947.026,2.737,3.854,5.458,7.72,8.2,11.574a1.608,1.608,0,0,1,.31,1.792c-.335.65-.935.714-1.582.712C1938.069-45.613,1935.248-45.608,1932.427-45.608Z",
  transform: "translate(-1434.715 360.607)",
  fill: "#02b4a7"
});

var SvgBannerImg = function SvgBannerImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1130.573 958.958",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "banner-img",
    transform: "translate(0 -0.02)"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M452.85,272.938l7.1,5.328,3.552-24.863Z",
    transform: "translate(99.667 55.767)",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _ref30, _ref31, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M331.316,252l1.624,22,51.525,27.044L338.637,270.3Z",
    transform: "translate(72.919 55.457)",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _ref32, _ref33, _ref34, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M330.812,306.41l59.543,26.338-61.2-11.961Z",
    transform: "translate(72.444 67.433)",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _ref35, _ref36));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBannerImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/banner-img.96448734.svg";
export { ForwardRef as ReactComponent };